export const GA_CLIP_CONTENT_TYPE = 'vertical clip'
/**
 * Calculates the height of a container element.
 *
 * @param {Element} element - The container element.
 * @returns {number} - The height of the container element.
 */
export function getContainerHeight (element) {
  const { height } = element.getBoundingClientRect()
  return Math.ceil(height * 100) / 100
}

/**
 * Calculates the anchors for slides based on their heights.
 *
 * @param {Array} slideRefs - Array of refs to slide elements.
 * @returns {Array} - Array of objects representing the start, end, height,
 * and index of each anchor.
 */
export function calculateAnchors (slideRefs = []) {
  return slideRefs.reduce((acc, ref, i) => {
    if (ref && ref.current) {
      const { height } = ref.current.getBoundingClientRect()
      const roundedHeight = Math.floor(height * 100) / 100
      const start = i === 0 ? 0 : acc[i - 1].end
      const end = start + roundedHeight
      acc.push({
        start,
        end,
        height: roundedHeight,
        index: i,
      })
    }
    return acc
  }, [])
}
